import { Header } from 'modules/checkout/presentation/components/molecules';
import { StatusInformation } from 'modules/checkout/presentation/components/organisms';
import { AllRightsFooter } from 'shared/presentation/components/atoms';
import { ANIMATIONS, TIconType } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';

import * as S from './styles';

interface IAction {
  text: string;
  icon: TIconType;
  onClick: () => void;
}

interface ICheckoutErrorProps {
  message: string;
  actions?: IAction[];
}

const CheckoutError: React.FC<ICheckoutErrorProps> = ({
  message,
  actions = [],
}) => {
  const { t } = useLocale('checkout');

  return (
    <S.Container>
      <Header />

      <StatusInformation
        animation={{
          data: ANIMATIONS.ERROR,
          width: 300,
          height: 150,
        }}
        title={t('Ops something went wrong')}
        message={message}
        actions={actions}
      />

      <AllRightsFooter />
    </S.Container>
  );
};

export default CheckoutError;
